import { useRef, useState } from 'react';

function Manual() {
	const viewer = useRef(null);
	const [entries, setEntries] = useState([]);
	const manualUrl = `${process.env.PUBLIC_URL || ''}/manual`;
	const downloadPdf = () => {
		const link = document.createElement('a');
		link.href = `${manualUrl}/Manual%20BailacORM.pdf`;
		link.download = 'Manual BailacORM.pdf';
		document.body.appendChild(link);
		link.click();
		link.remove();
	};

	const buildIndex = () => {
		const doc = viewer.current?.contentDocument;
		if (!doc) return;

		const index = [];
		doc.querySelectorAll('.page').forEach((page, pageIndex) => {
			if (page.classList.contains('no-toc')) return;
			page.querySelectorAll('h1, h2').forEach(heading => {
				const title = heading.textContent.trim();
				if (title) index.push({ title, level: heading.tagName, page, number: pageIndex + 1 });
			});
		});
		setEntries(index);
	};

	return (
		<form onSubmit={event => event.preventDefault()}>
			<aside>
				<article>
					<h2>Acciones</h2>
					<fieldset>
						<input type="button" value="Descargar PDF" onClick={downloadPdf} />
					</fieldset>
				</article>
				<article>
					<h2>Índice</h2>
					<fieldset className="scroll" style={{ maxHeight: '500px' }}>
						<ul aria-label="Índice del manual">
							{entries.map((entry, index) => (
								<li key={index}>
									<p>
										<a
											href={`${manualUrl}/index.html`}
											title={`Ir a la página ${entry.number}`}
											onClick={event => {
												event.preventDefault();
												entry.page.scrollIntoView({ behavior: 'smooth', block: 'start' });
											}}
										>
											{entry.level === 'H1' ? <strong>{entry.title}</strong> : entry.title}
										</a>
									</p>
								</li>
							))}
						</ul>
					</fieldset>
				</article>
			</aside>
			<main>
				<h1 data-icon="">Manual</h1>
				<article style={{ paddingBottom: 0, height: 'calc(100vh - 130px)' }}>
					<iframe
						ref={viewer}
						src={`${manualUrl}/index.html`}
						title="Manual de uso BailacORM"
						onLoad={buildIndex}
					/>
				</article>
			</main>
		</form>
	);
}

export default Manual;
